<template>
  <v-container>
    <v-row justify="center"><h2>Moje voľné termíny</h2></v-row>
    <v-row justify="center">
      <v-col cols="10">
        <p>
          Jednoducho si vyber dátum a čas (začiatku upratovania), kedy môžeš
          poskytnuť upratovaciu službu a klikni na tlačidlo "Pridať". Termíny
          ktoré pridaš môžeš kedykoľvek zrušiť. Ak si niekto objedná tvoju
          službu na daný termín, objednavku môžeš schváliť alebo odmietnuť.
        </p>
        <p class="warning--text">
          <em
            >Termíny vyberaj zodpovedne. Ak si navoliš termíny tesne blízko
            seba, nemusíš stihnuť poskytnuť službu všetkym zákaznikom v
            objednanom čase, to sa môže negatívne prejaviť na tvojom
            hodnotení. Minimalný rozostup medzi termínmi je jedna hodina.</em
          >
        </p>
      </v-col>
    </v-row>


    <v-row justify="center" align="center">
      <v-col cols="2">
        <v-text-field
          :rules="rules"
          v-model="day"
          class="subtitle-2 text-center"
          label="Deň"
          placeholder="DD"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          :rules="rules"
          v-model="month"
          class="subtitle-2 text-center"
          label="Mesiac"
          placeholder="MM"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          :rules="rules"
          v-model="year"
          class="subtitle-2 text-center"
          label="Rok"
          placeholder="RRRR"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          :rules="rules"
          v-model="hour"
          class="subtitle-2 text-center"
          label="Hodina"
          placeholder="HH"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          :rules="rules"
          v-model="minute"
          class="subtitle-2 text-center"
          label="Minúta"
          placeholder="MM"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="6" class="d-flex justify-center">

            <v-btn @click="addTerm()" color="accent darken-2">Pridaj termín </v-btn>

      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="10" md="8">
        <v-card height="100" color="transparent" flat>
        <v-alert type="success" :value="alert" transition="slide-y-transition">
          Termín bol uspešne pridaný.
        </v-alert>
        <v-alert type="error" :value="error" transition="slide-y-transition">
          Zadány datúm alebo čas je chybný! 
        </v-alert>
        <v-alert type="error" :value="alreadyAdded" transition="slide-y-transition">
          Termín musí byť vzdialeny aspoň hodinú od všetkých existujucích terínov.
        </v-alert>
        </v-card>
      </v-col>
      
    </v-row>
    <v-row justify="center" ><h3>Tvoje voľné termíny</h3></v-row>
    <v-row justify="center">
      <v-col cols="10">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Dátum</th>
                <th class="text-left">Čas</th>
                <th class="text-left">Zrušiť termín</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in terms" :key="index">
                <td>{{ getEuroDate(item.date) }}</td>
                <td>{{ item.time }}</td>
                <td>
                  <v-icon 
                    color="primary"
                    @click="wantDelete(item)"
                    >
                      mdi-delete
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog
      max-width="290"
      v-model="dialog"
    >
    
      <v-card>
        <v-card-text class="headline">
          Naozaj chceš zrušiť termín?
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error darken-1"
            text
            @click="dialog = false"
          >
            Nie
          </v-btn>
          <v-btn
            color="green darken-2"
            text
            @click="deleteTerm()"
          >
            Áno
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as axios from "axios";
import store from "@/store/store";
export default {
  name: "TermsAdministration",
  data() {
    return {
      al_minutes: [0, 15, 30, 45],
      alert: false,
      error: false,
      alreadyAdded: false,
      terms: [],
      dialog: false,
      toDelete: null,
      day: null,
      month: null,
      year: null,
      hour: null,
      minute: null
    };
  },
  methods: {
    createDate(){
        if(this.day && this.month && this.year && this.hour && this.minute){
            let milisecs = Date.parse(`${this.year}-${this.month}-${this.day} ${this.hour}:${this.minute}`);
            if(milisecs-Date.now() < 0) return "";
            if(milisecs){
                return new Date(milisecs);
            }
        }
        return ""
    },
    wantDelete(term){
      this.toDelete = term
      this.dialog = true;
    },
    deleteTerm(){
      this.dialog = false;
      const params = new URLSearchParams();
      params.append("cleaner", localStorage.getItem('loggedUserId'));
      params.append("date", this.toDelete.date);
      params.append("time", this.toDelete.time);
      axios({
        method: "post",
        url: store.state.url.concat("deleteTerm.php"),
        data: params,
      }).then(
          response => {
            if (response.data.result == true){
              console.log("deleted");
            }
          },
          error => {
            console.log(error);
          }
      )
      this.terms = this.terms.filter((datetime)=>{
        return (datetime.date !== this.toDelete.date || datetime.time !== this.toDelete.time);
      });
    },
    addTerm() {
      let term = this.createDate();
      
      if(!term) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 1500);
      }
      else if(this.dateExists(term)){
        this.alreadyAdded = true;
        setTimeout(() => {
          this.alreadyAdded = false;
        }, 2500);
      }
      else{
        let date = `${this.year}-${this.month}-${this.day}`
        let time = ("0"+this.hour).slice(-2)+":"+("0"+this.minute).slice(-2);
        const params = new URLSearchParams();
        params.append("cleaner", localStorage.getItem('loggedUserId'));
        params.append("date", date);
        params.append("time", time);
        axios({
          method: "post",
          url: store.state.url.concat("addTerm.php"),
          data: params,
        }).then(
            response => {
              if (response.data.result == true){
                console.log("deleted");
              }
            },
            error => {
              console.log(error);
            }
        )
        this.terms.push({date: date, time: time})
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 1500);

        this.sortTerms();
      } 
    },
    sortTerms(){
        this.terms = this.terms.sort(
          (datetime1, datetime2)=>{
            const arr1 = datetime1.date.split("-").concat(datetime1.time.split(":"));
            const arr2 = datetime2.date.split("-").concat(datetime2.time.split(":"));
            let substraction = 0;
            for(let i = 0; i<arr1.length; i++){
              substraction = parseInt(arr1[i])-parseInt(arr2[i])
              if(substraction !== 0) return substraction;
            }
            return substraction;
          }
        );
    },
    dateExists(term){
      for(let datetime of this.terms){
          let term2 = new Date(`${datetime.date} ${datetime.time}`)
          let rozdiel = Math.abs((term-term2)/1000/60/60);
          if(rozdiel < 1){
              return true;
          }
      }
      return false;
    },
    getEuroDate(date) {
      var myDate = new Date(date);
      return (
            ("0" + myDate.getDate()).slice(-2) + "." + ("0" + (myDate.getMonth() + 1)).slice(-2)  + "." + myDate.getFullYear()
        );
    },
    getMyTerms(){
        axios.get(store.state.url.concat('getTerms.php'), {
            params: {
            user:  localStorage.getItem('loggedUserId')
            }
        }).then((response) => {
            if(response.data.result){
            if(response.data.result == 'noTerms') {
                this.terms = [];
            }
            }else{
                this.terms = response.data;
                this.sortTerms();
            }
        })
    }
  },
  created: function(){
        this.getMyTerms();
    },
  computed: {
      rules() {
        const rules = [];
        const regex = /^[0-9]+$/;
        const rule = v => (!!v && regex.test(v)) || "";
        const rule2 = v => (v !==null && v !== "") || "";
        rules.push(rule2);
        rules.push(rule);//na poradi zalezi
        return rules
      }
    },
};
</script>

<style>
</style>